import { isCPF, isCEP } from 'brazilian-values';
import { differenceInYears } from 'date-fns';
import { convertStringToDate } from 'utils/convertStringToDate';
import * as yup from 'yup';

const commonFields = {
  fullName: yup.string().required('Nome completo é obrigatório'),
  email: yup.string().email('E-mail inválido').required('E-mail obrigatório'),
  cep: yup
    .string()
    .required('CEP é obrigatório')
    .test('cep Test', 'CEP inválido', (value) => isCEP(value)),
  firstPhone: yup
    .string()
    .required('Telefone 1 é obrigatório')
    .length(16, 'Deve conter 11 dígitos'),
  secondPhone: yup.string().min(15, 'Mínimo de 10 dígitos').max(16, 'Máximo de 11 dígitos'),
  state: yup.string().required('Estado é obrigatório'),
  city: yup.string().required('Cidade é obrigatória'),
  cpf: yup
    .string()
    .required('CPF obrigatório')
    .test('cpf Test', 'CPF inválido', (value) => !!value && isCPF(value)),
  birthDate: yup
    .string()
    .required('Data de nascimento é obrigatória')
    .test('format', 'Formato inválido', (value) => {
      const parts = value.split('/');
      return parts.length === 3 && parts[2].length === 4;
    })
    .test('age', 'Idade inválida', function (value) {
      const birthDate = convertStringToDate(value);
      const age = differenceInYears(new Date(), birthDate);
      return age >= 18 && age <= 100;
    }),
  number: yup.number().typeError('Campo somente aceita números'),
  sex: yup.string().required('Sexo é obrigatório'),
  neighborhood: yup
    .string()
    .required('Campo obrigatório')
    .min(2, 'Mínimo de caracteres não fornecido'),
  street: yup.string().required('Campo obrigatório').min(2, 'Mínimo de caracteres não fornecido'),
};

const passwordFields = {
  password: yup
    .string()
    .required('Senha obrigatória')
    .min(8, 'Mínimo de 8 caracteres')
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/? ]{8,}$/,
      'A senha deve conter pelo menos uma letra maiúscula, uma letra minúscula, um número e ter no mínimo 8 caracteres',
    ),
  passwordConfirmation: yup
    .string()
    .required('Confirmação de senha obrigatória')
    .oneOf([yup.ref('password'), ''], 'Senhas não coincidem'),
};

const registerCommonFields = {
  ...passwordFields,
  ...commonFields,
};

export const registerFormSchema = yup.object().shape(registerCommonFields);

export const updateProfileFormSchema = yup.object().shape(commonFields);

export const recoverPasswordFormSchema = yup.object().shape({
  email: yup.string().email('E-mail inválido').required('E-mail obrigatório'),
});

export const changePasswordFormSchema = yup.object().shape(passwordFields);
